import React from "react";

import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/Auth/auth-context";
import useUserRoleStore from "../../store/user-role";
import { ADMIN_LOGIN } from "../../utils/routes";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isLoggedIn } = useAuth();
  const { role } = useUserRoleStore();

  if (!isLoggedIn) {
    return <Navigate replace to={ADMIN_LOGIN} />;
  }

  if ((role && !allowedRoles.includes(role)) || !role) {
    return <Navigate replace to={ADMIN_LOGIN} />;
  }
  return children;
};

export default ProtectedRoute;
